import React from "react"
import { CardActionArea, CardContent, Typography, Card } from "@mui/material";
import Box from "@mui/material/Box";

const RecipeCard = (props) => {
    const { title, id } = props
    const styles = {
        boxShadow: 'none',
        borderColor: 'lightgrey',
        border: '1px solid'
    }

    return (
        <CardActionArea href={`recipes/${id}`}>
            <Card sx={styles}>
                <CardContent sx={{'&:last-child': {pb: '16px'}}}>
                    <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center" height="100%">
                        <Typography variant="h8" component="div">{title}</Typography>
                    </Box>
                </CardContent>
            </Card>
        </CardActionArea>
    );
}

export default RecipeCard
